import Output      from '../Output';
import Color       from '../../../../Lib/Color';
import IncludeHash from '../Options/IncludeHash';

export default class Hex extends Output {

    static availableOptions = [IncludeHash];

    output() {
        let color = Color.ensureColor(this.subject.color);

        return color.hex().value.substr(1);
    }

}